import property_icon from "../../../../assets/images/property-icon.png"

export const roomsData = [
    {
        icon: property_icon,
        room_id: "101",
        room_type: "(Standard)",
        guest_name: "Mr. John Doe",
        add_ons: "Room with Breakfast",
    },
    {
        icon: property_icon,
        room_id: "102",
        room_type: "(Deluxe)",
        guest_name: "Ms. Jane Smith",
        add_ons: "Room Only",
    },
    {
        icon: property_icon,
        room_id: "103",
        room_type: "(Suite)",
        guest_name: "Mr. Emily Johnson",
        add_ons: "Room with Breakfast, Lunch and Dinner",
    },
    {
        icon: property_icon,
        room_id: "104",
        room_type: "(Standard)",
        guest_name: "Mr. Michael Brown",
        add_ons: "Room with Breakfast and Lunch",
    },
    {
        icon: property_icon,
        room_id: "105",
        room_type: "(Superior)",
        guest_name: "Ms. Sarah Davis",
        add_ons: "Room Only",
    }
]
